export default __webpack_public_path__ + "static/media/img14.c809510d.PNG";